import React, { lazy, Suspense } from 'react';
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';

import { IConfig } from '../../Interfaces/IConfig';
import { Loader } from '../generic/Loader';
import Layout from '../private/Layout';

const LegalTransactionOverview = lazy(() =>
  import('../private/LegalTransaction/LegalTransactionOverview').then(m => ({
    default: m.LegalTransactionOverview,
  }))
);
const LegalTransactionDetailPage = lazy(() =>
  import('../private/LegalTransaction/LegalTransactionDetailPage').then(m => ({
    default: m.LegalTransactionDetailPage,
  }))
);
const ClientEdit = lazy(() =>
  import('../private/Client/ClientEdit').then(m => ({ default: m.ClientEdit }))
);

interface IProps {
  configObject: IConfig;
}

export const PageRouter: React.FC<IProps> = ({ configObject }) => {
  return (
    <Router>
      <Layout configObject={configObject}>
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route
              index
              element={<LegalTransactionOverview configObject={configObject} />}
            />
            <Route
              path='/:idLegalTransaction'
              element={<LegalTransactionDetailPage configObject={configObject} />}
            />
            <Route path='/account' element={<ClientEdit />} />
            <Route path='*' element={<Navigate to='/' replace />} />
          </Routes>
        </Suspense>
      </Layout>
    </Router>
  );
};
